<template>
  <div class="header__wrapper" role="complementary">
    <al-step-tracker
      v-if="showStepTracker"
      :steps="totalStep"
      :active-step="activeStep"
      name="step-tracker"
      :label="$t('stepTracker.label', { activeStep, totalStep })"
      class="margin-top-md" />
  </div>
</template>

<script>
import { AlStepTracker } from '@mc-alberta/alcapone'
import { mapState } from 'vuex'
import { TOTAL_STEPS } from '@/constants'

export default {
  name: 'StepTracker',
  components: { AlStepTracker },
  computed: {
    ...mapState({
      stepMap: (state) => state.stepMap
    }),
    activeStep() {
      return this.stepMap?.[this.$route.name] || 0
    },
    totalStep() {
      return this.$route.params.totalStep || TOTAL_STEPS
    },
    showStepTracker() {
      return this.$route.params.showStepTracker || this.activeStep
    }
  }
}
</script>
